module.exports = __webpack_public_path__ + "static/media/group-of-friends.eb3328e9.jpg";